import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import { CalendarToday, FormatListBulleted } from '@material-ui/icons';

//TODO: PropTypes
const SorterButtons = ({ sortByValue = 'default', onChange }) => {
  return (
    <div>
      <IconButton style={{
        padding: '5px',
        ...(!(sortByValue === 'default') && {
          background: '#fff'
        }),
      }} color="primary" disabled={sortByValue === 'default'}>
        <Tooltip title="Sort by Booking Date">
          <FormatListBulleted style={{
            height: '20px',
            width: '20px'
          }} onClick={() => onChange('default')} />
        </Tooltip>
      </IconButton>
      <IconButton style={{
        padding: '5px',
        ...(!(sortByValue === 'noteDate') && {
          background: '#fff'
        }),
      }} color="primary" disabled={sortByValue === 'noteDate'}>
        <Tooltip title="Sort by Note Date">
          <CalendarToday style={{
            height: '20px',
            width: '20px'
          }} onClick={() => onChange('noteDate')} />
        </Tooltip>
      </IconButton>
    </div>
  );
};

export default SorterButtons;
